<template>
  <h2 :id="id" :class="$style.title"><slot></slot></h2>
</template>

<script>
export default {
  name: "vc-share-info-title",
  props: {
    id: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module>
.title {
  font-size: 21px;
  padding-top: 80px;
  color: gray;
  font-weight: 700;
  border-bottom: 1px solid gray;
  margin: -48px 0 16px;
}
</style>
